import * as React from 'react';
import ResizeObserverPolyFill from 'resize-observer-polyfill';
import invariant from 'tiny-invariant';
import debounce from 'lodash/debounce';

/** Get the width of component passed as reference */
export function useContainerSize(ref, timeOut = 0) {
  const [size, setSize] = React.useState(0);
  const flag = React.useRef(false);
  React.useLayoutEffect(() => {
    invariant(ref?.current, 'The ref should point to an existing DOM Node');
    const resize = () => {
      if (!flag.current && ref?.current !== undefined && ref?.current !== null) {
        flag.current = true;
        setSize(ref?.current?.offsetWidth);
      }
    };
    const observer = new ResizeObserverPolyFill(timeOut ? debounce(resize) : resize);
    observer.observe(ref?.current);
    return () => observer.disconnect();
  }, [ref, timeOut]);

  return size;
}
